import { useEffect, useRef } from "react";

const SUGGESTIONS = [
  "Summarize our current cash position and outstanding AR.",
  "Which products are running low on stock?",
  "How much is our monthly payroll and how is headcount split by department?",
  "Highlight any overdue invoices and risks.",
];

function Message({ msg, isLast, streaming }) {
  return (
    <div className={msg.role === "user" ? "pl-8" : ""}>
      <div className="flex items-start gap-2">
        {msg.role === "assistant" ? (
          <span className="font-mono text-[10px] text-[#FF3E00] mt-0.5">▸</span>
        ) : (
          <span className="font-mono text-[10px] text-zinc-400 mt-0.5">$</span>
        )}
        <div
          className={`text-sm leading-relaxed whitespace-pre-wrap flex-1 ${
            msg.role === "user" ? "text-zinc-600 font-medium" : "text-zinc-950"
          }`}
        >
          {msg.content || (streaming && isLast ? <span className="font-mono text-zinc-400">thinking…</span> : null)}
        </div>
      </div>
    </div>
  );
}

export default function CopilotMessages({ messages, streaming, onSuggestion }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, streaming]);

  return (
    <div ref={scrollRef} className="flex-1 overflow-y-auto px-4 py-4 space-y-4" data-testid="copilot-messages">
      {messages.map((m, i) => (
        <Message key={m.id} msg={m} isLast={i === messages.length - 1} streaming={streaming} />
      ))}
      {messages.length === 1 && (
        <div className="pt-4 space-y-2">
          <div className="label-sm text-zinc-400">Try asking</div>
          {SUGGESTIONS.map((s, i) => (
            <button
              key={s}
              onClick={() => onSuggestion(s)}
              className="block text-left text-xs text-zinc-700 hover:text-[#FF3E00] hover:bg-zinc-50 border border-zinc-200 hover:border-zinc-950 px-3 py-2 w-full transition-colors"
              data-testid={`copilot-suggestion-${i}`}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
